import React, {FC} from 'react'
import styles from './Show.scss'
import {SYSTEM_ANNOUNCE, QueryResult} from './query'
import {useParams} from 'react-router-dom'
import {useQuery} from 'hooks/graphql'
import {Loading} from 'components/ui/Loading'
import moment from 'moment'
import {prepareHtmlForDisplay} from 'libs/prepareHtmlForDisplay'

interface MatchParams {
  id: string
}

export const Show: FC = () => {
  const {id} = useParams<MatchParams>()

  const {data, loading} = useQuery<QueryResult>(SYSTEM_ANNOUNCE, {
    variables: {id: id},
  })
  const systemAnnounce = data?.systemAnnounce
  return (
    <>
      <div className="l-main-title-wrap">
        <h1 className="m-title-main">お知らせ</h1>
      </div>
      {loading ? (
        <Loading />
      ) : (
        systemAnnounce && (
          <div className="l-wrap-s">
            <div className={styles.date}>{moment(systemAnnounce.publishAt).format('YYYY年MM月DD日 HH:mm')}</div>
            <h2 className={styles.title}>{systemAnnounce.title}</h2>
            {systemAnnounce.label && <div className={styles.label}>{systemAnnounce.labelName}</div>}
            <div
              className={styles.body}
              dangerouslySetInnerHTML={{__html: prepareHtmlForDisplay(systemAnnounce.body)}}
            />
          </div>
        )
      )}
    </>
  )
}
